module.exports = __webpack_public_path__ + "static/media/modal-backing-9-slice.956c2f42.png";